import React from 'react';
import { Button, Tooltip } from 'antd';
import { Translate } from '@above-the-treeline/localization';

export default class BrowseFilterDisplay extends React.Component {
	render() {
		const {
			value,
			label,
			isExclusion,
			idx,
			includeBullet,
			isEditable,
		} = this.props;

		return (
			<React.Fragment>
				{idx > 0 && includeBullet ? (
					<div className="column-spaced">&bull;</div>
				) : (
					''
				)}
				<Tooltip
					placement="bottomRight"
					title={
						<Translate
							id={
								isExclusion
									? 'filter_excluded'
									: 'filter_included'
							}
						/>
					}>
					<div
						className={`column-narrow icon-${
							isExclusion
								? 'minus-circle category-exclusion'
								: 'plus-circle category-inclusion'
						}`}
					/>
				</Tooltip>
				<div className="column-narrow">{label}</div>
				{isEditable && (
					<>
						<div className="column-right">
							<Tooltip title={<Translate id="remove" />}>
								<Button
									size="small"
									onClick={() =>
										this.props.removeFilter(value)
									}>
									<div className="icon-trash remove-filter-trash" />
								</Button>
							</Tooltip>
						</div>
						<div className="column-spaced-right">
							<Tooltip
								title={
									<Translate
										id={
											isExclusion
												? 'include_in_filter'
												: 'exclude_from_filter'
										}
									/>
								}>
								<Button
									size="small"
									onClick={() =>
										this.props.changeExclusion(value)
									}>
									<div
										className={`icon-${
											isExclusion ? 'plus' : 'minus'
										}-circle remove-filter-trash`}
									/>
								</Button>
							</Tooltip>
						</div>
					</>
				)}
				<div className="clear" />
			</React.Fragment>
		);
	}
}
